import { z } from "zod";

/**
 * Zod schema for Shopify form validation
 * Messages updated to use translation keys
 */
export const shopifySchema = z.object({
    companyEmail: z
        .string()
        .min(1, "errors.emailRequired")
        .email("errors.invalidEmail"),
    companyUrl: z
        .string()
        .min(1, "errors.shopifyUrlRequired")
        .url("errors.invalidUrl")
        .refine(
            (url) => url.includes("myshopify.com") || url.includes("shopify.com"),
            "errors.shopifyUrlFormat"
        ),
});
